import React from 'react'
import { Button } from '@material-ui/core';

const AcceptGroupInviteButton = ({ handleVerifyMembership, groupDetail }) => {
  return <Button onClick={() => handleVerifyMembership(groupDetail, true)} variant="contained">Accept</Button> 
}

export default AcceptGroupInviteButton